import Donna from "../../../assets/Team/Donna.png";
import Jakub from "../../../assets/Team/Jakub.png";
import MaleDefault from "../../../assets/Team/male_default.png";
import Serin from "../../../assets/Team/Serin.png";
import Dylan from "../../../assets/Team/Dylan.png";
import HiepHuynh from "../../../assets/Team/HiepHuynh.png";
import TuanHoang from "../../../assets/Team/TuanHoang.png";
import Oliver from "../../../assets/Team/Oliver.png";
import John from "../../../assets/Team/John Bassilios.png";
import MarkWilliam from "../../../assets/Team/MarkWilliam.png";
import Ben from "../../../assets/Team/Ben.png";
import Wanda from "../../../assets/Team/Wanda.png";

const profile = [
  {
    photo: Jakub,
    name: "Jakub Sawczuk",
    title: "Founder / CEO / CFO",
    linkedin: "https://www.linkedin.com/in/jakubsawczuk/",
    // twitter: "https://twitter.com/jakub_l_sawczuk",
    des: "Jakub is a certified accountant with over a decade of experience in Financial Management and Systems Integration. Before that Jakub has spent another decade as a Product Designer Engineer working for companies such as GE across Europe and the US and completing high end technical and corporate courses in collaboration with Georgia Tech in the US. Jakub holds undergraduate degrees acquired at universities in Australia (Swinburne, Melbourne), Holland (Hanzehogeschool, Groningen) and Spain (CPS, Zaragoza), as well as postgraduate certification in Accounting (Swinburne). Jakub holds provisional membership of the Chartered Accountants (Deakin), membership of the Institute of Certified Bookkeepers and a membership of Tax Practitioners Board of Australia as a BAS Agent. Jakub’s role is to manage the team and the operations, but at the same time to lead and verify lot of the conceptualisation of the systems developed by AEM.",
  },

  {
    photo: Serin,
    name: "Serin Park",
    title: "Operations/ Design",
    role: "UI/UX",
    linkedin: "https://www.linkedin.com/in/serin-park/?originalSubdomain=au",
    twitter: "",
    des: "Serin Park is a multi-disciplinary designer with a passion for User Experience and Interface(UX/UI) design. Her background is in Communication Design and Visual art with 2 years experience in a diverse range of industries. She uses visual communications as a way of exploring and understanding human experience.",
  },
  {
    photo: MaleDefault,
    name: "Duy Anh",
    title: "Full Stack Developer",
    linkedin: null,
    role: "Full Stack Developer",
    twitter: "",
    des: "Leanne is a Campaign Strategist at AEM Algorithm, focusing on the company blog and social media campaigns. With a strong background in copywriting and content creation, Leanne specialises in combining creativity and innovative marketing with strategic research and methodical thinking. She implements a unique human-centred approach to marketing by helping B2B and B2C brands connect authentically and empathetically with their desired audiences. Leanne graduated with High Distinction in the Bachelor of Communications (Professional Communication) at RMIT University with a specialisation in Media.",
  },
  {
    photo: TuanHoang,
    name: "Tuan Hoang",
    title: "Full Stack Developer",
    role: "Full Stack Developer",
    linkedin: "https://www.linkedin.com/in/tuan-hoang-a536b320a/  ",
    twitter: "",
  },
  {
    photo: Dylan,
    name: "Dylan Tran",
    title: "Full Stack Developer",
    role: "Full Stack Developer",
    linkedin: null,
    twitter: "",
    des: "",
  },
  {
    photo: HiepHuynh,
    name: "Hiep Huynh Van",
    title: "Frontend Developer",
    role: "Frontend Developer",
    linkedin: null,
    twitter: "",
    des: "",
  },
  {
    photo: Oliver,
    name: "Oliver Liu",
    title: "Analytics & Business Development",
    role: "Analytics & Business Development",
    linkedin: "https://www.linkedin.com/in/oliver-liu-iwnl/ ",
    twitter: "",
    des: "",
  },
];

const Advisors = [

  {
    photo: John,
    name: "John Bassilios ",
    title: "Advisor",
    linkedin: "https://www.linkedin.com/in/john-bassilios-b0a2802/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    role: "Marketing",
    twitter: "",
    des: "Leanne is a Campaign Strategist at AEM Algorithm, focusing on the company blog and social media campaigns. With a strong background in copywriting and content creation, Leanne specialises in combining creativity and innovative marketing with strategic research and methodical thinking. She implements a unique human-centred approach to marketing by helping B2B and B2C brands connect authentically and empathetically with their desired audiences. Leanne graduated with High Distinction in the Bachelor of Communications (Professional Communication) at RMIT University with a specialisation in Media.",
  },
  {
    photo: MaleDefault,
    name: "Dominic Bowen",
    title: "Enterprise Solutions",
    linkedin: null,
    twitter: "",
    des: "",
  },
  {
    photo: Donna,
    name: "Donna McConnell",
    title: "Community Engagement",
    linkedin: "https://www.linkedin.com/in/iswys-donnamcconnell/",
    twitter: "",
    des: "",
  },
  {
    photo: MarkWilliam,
    name: "Mark Williams",
    title: "Cyber & AI (Quigly)",
    linkedin: "https://www.linkedin.com/in/markwilliamsmelbourne/",
    twitter: "",
    des: "",
  },
  {
    photo: Ben,
    name: "Ben Berenson",
    title: "Business Advisor",
    linkedin: "https://www.linkedin.com/in/bberenson/",
    twitter: "",
    des: "",
  },
  {
    photo: Wanda,
    name: "Wanda Jablonska",
    title: "Business Advisor",
    linkedin: "https://www.linkedin.com/in/wanda-j-a0927515/",
    twitter: "",
    des: "",
  },
];

export { profile, Advisors };

